import { useContext } from 'react';
import { CacheServiceContext } from '../service/CacheService';

export const useCacheService = () => {
    const context = useContext(CacheServiceContext);
    return context;
};
